import { objectStore } from "@budibase/backend-core"

export const budibaseTempDir = objectStore.budibaseTempDir
